import { FEATURE_FLAG_DEFAULTS } from './featureFlags';

const TENANT_INITIAL_STATE = {
  identifier: '',
  pipelineId: '',
  branch: '',
  name: '',
  webAppUrl: '',
  selectionAlgorithmNotebookUrl: '',
  translationProvider: 'google',
  googleAnalyticsId: '',
  homePageConfiguration: {
    branding: {
      brandingType: 'generic',
      details: {
        // "primaryColor": "",
        // "secondaryColor": ""
      },
    },
    siteName: '',
    programLongName: '',
    programShortName: '',
    signInMessage: '',
    fontFamilyName: '',
  },
  readerConfiguration: {
    maxReadsByReader: 0,
    requiredReads: 0,
    diverseEthnicity: false,
  },
  featuresConfiguration: { ...FEATURE_FLAG_DEFAULTS },
  donationPageConfiguration: {
    isCtaVisible: false,
  },
  fundsDisbursement: 'student',
  legalConfiguration: {
    copyrightLanguage: '',
    privacyPolicy: ' ',
  },
  bannerConfiguration: {
    isBannerEnabled: false,
    title: '',
    description: '',
  },
  codeFlags: [],
  // "databaseConfiguration": {
  //     "hostName": "",
  //     "databaseName": "",
  //     "username": "",
  //     "password": ""
  // },
  // "sendGridConfiguration": {
  //     "apiKey": "",
  //     "senderEmail": "",
  //     "templates": []
  // },
  // "twilioConfiguration": {
  //     "authToken": "",
  //     "accountSid": "",
  //     "phoneNumber": ""
  // }
};

export default TENANT_INITIAL_STATE;
